/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../../../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { DashboardService } from '../../../../../services';

const MODULE_NAME = "machines.trag.states.getRoles";
const log: any = LoggerModule?.getInstance();


const getPersonasService = () => {
    const vapp = VApplication.getInstance();
    const personasService = vapp.getSync(
        "services.DashboardService"
    ) as DashboardService;
    return personasService;
};

export const getRoles = async (context: any, event: any) => {
    return new Promise(async (resolve, reject) => {
        try {
            log.blue(MODULE_NAME, "context: ", context, "event: ", event);
            const personasService = getPersonasService();
            const persona: any = await personasService.getMyRole();
            if(persona)
            {
                setTimeout(()=>{
                    return resolve({
                        key: "RENDER_ROLES",
                        value: {
                            ...(persona || {}),
                        },
                    });
                },2000)
           
            } else {
                return reject({
                    key: "RENDER_ROLES",
                    value: "Roles Not Found",
                });
            }
        } catch (err) {
            return reject({
                key: "RENDER_ROLES_ERROR",
                value: err?.message,
            });
        }
    });
}